import {
  project1Laptop,
  project1Mobile,
  project2Laptop,
  project2Mobile,
  project3Laptop,
  project3Mobile,
  project4Laptop,
  project4Mobile,
  project5Laptop,
  project5Mobile,
  project6Laptop,
  project6Mobile,
} from "./projectImages";

export const projectData = [
  {
    id: 1,
    image: project1Laptop,
    transitionImage: project1Mobile,
    title: "A meditation app",
    codeLink: "https://github.com/monciego/meditation-app",
    liveLink: "https://umatter.netlify.app/",
  },
  {
    id: 2,
    image: project2Laptop,
    transitionImage: project2Mobile,
    title: "Restaurant Website",
    codeLink: "https://github.com/monciego/lediable-restaurant",
    liveLink: "https://lediable.netlify.app/",
  },
  {
    id: 3,
    image: project3Laptop,
    transitionImage: project3Mobile,
    title: "Interior Design Company",
    codeLink: "https://github.com/monciego/elegancev1",
    liveLink: "https://eleganceee.netlify.app/",
  },
  {
    id: 4,
    image: project4Laptop,
    transitionImage: project4Mobile,
    title: "IT Company",
    codeLink: "https://github.com/monciego/coderig-landing-page",
    liveLink: "https://codeegrid.netlify.app/",
  },
  {
    id: 5,
    image: project5Laptop,
    transitionImage: project5Mobile,
    title: "Gym Fitness Website",
    codeLink: "https://github.com/monciego/intrepide",
    liveLink: "https://intrepide.netlify.app/",
  },
  {
    id: 6,
    image: project6Laptop,
    transitionImage: project6Mobile,
    title: "Space Tourism",
    codeLink: "https://github.com/monciego/space-tourism",
    liveLink: "https://spacetourism-monciego.netlify.app/",
  },
];
